var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.921 33.461C20.6425 27.0073 19.0844 18.8856 13.2159 14.1507C13.2125 14.1481 13.2091 14.1447 13.2063 14.1427L13.2317 14.2043L13.2276 14.2505C14.371 17.2008 14.2106 20.4397 12.806 23.2186L11.8162 25.1779L11.5125 23.0131C11.3062 21.5446 10.7393 20.1438 9.86598 18.9445H9.7282L9.65554 18.7436C9.66582 20.9875 9.18187 23.1979 8.23247 25.283C6.98695 28.0117 7.16997 31.1582 8.72259 33.7014L9.794 35.4571L7.86642 34.6616C4.68783 33.3499 2.14674 30.8228 0.894363 27.7285C-0.508823 24.2733 -0.249025 20.267 1.59013 17.014C2.54912 15.3219 3.2209 13.5253 3.58763 11.6732L3.94614 9.85784L4.86057 11.477C5.29723 12.249 5.61872 13.0847 5.81819 13.9626L5.83876 13.9833L5.86001 14.1239L5.87989 14.1179C8.61908 10.5629 10.2601 6.13948 10.4994 1.66044L10.5611 0.5L11.5578 1.13479C15.6254 3.72419 18.4503 7.87846 19.3229 12.5463L19.3428 12.6421L19.3531 12.6568L19.3976 12.5952C20.1949 11.5667 20.6157 10.3433 20.6157 9.05564V7.06154L21.8476 8.6512C24.7115 12.3461 26.1798 16.9296 25.9824 21.558C25.7397 27.006 22.6982 31.7877 17.8457 34.3784L15.7447 35.5L16.921 33.461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.46008f7c37cb605231eb9eb7dde05ea2.svg";
export { ForwardRef as ReactComponent };